import { render, staticRenderFns } from "./DpvTable.vue?vue&type=template&id=44342adc&scoped=true"
import script from "./DpvTable.vue?vue&type=script&lang=js"
export * from "./DpvTable.vue?vue&type=script&lang=js"
import style0 from "./DpvTable.vue?vue&type=style&index=0&id=44342adc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44342adc",
  null
  
)

export default component.exports